class CarouselBannerBlock {
    constructor(el) {
        this.element = el;
        this.slideIndex = 0;
        this.animating = false;
        this.autoTimeout = null;
        this.autoTimeoutDuration = 5000;
        if(this.getSlides().length === 1) {
            return;
        }
        this.bindListeners();
        this.autoTimeout = setTimeout(this.nextSlide.bind(this), this.autoTimeoutDuration);
    }

    bindListeners() {
        let self = this;
        let buttons = this.getButtons();
        for(let i = 0; i < buttons.length; i += 1) {
            buttons[i].addEventListener('click', this.onButtonClick.bind(this, i));
        }
    }

    changeSlide(index, right=null) {
        let self = this;
        if(this.animating || index === this.slideIndex) {
            return;
        }
        this.animating = true;
        if(this.autoTimeout !== null) {
            clearTimeout(this.autoTimeout);
            this.autoTimeout = null;
        }
        if(right === null) {
            right = (index > this.slideIndex);
        }

        // Set up slides for moving
        let currentSlide = this.getCurrentSlide();
        let newSlide = this.getSlides()[index];
        currentSlide.classList.remove('-in-right')
        currentSlide.classList.remove('-in-left');
        currentSlide.classList.remove('-in');
        let onAnimationEnd = function() {
            currentSlide.classList.remove('-out-right')
            currentSlide.classList.remove('-out-left');
            self.animating = false;
            self.slideIndex = index;
            this.removeEventListener('animationend', onAnimationEnd);
            self.autoTimeout = setTimeout(self.nextSlide.bind(self), self.autoTimeoutDuration);
        };
        newSlide.addEventListener('animationend', onAnimationEnd);
        this.getButtons().forEach(function(button, buttonIndex) {
            button.parentElement.classList.toggle('-selected', (buttonIndex === index));
        });
        if(right) {
            currentSlide.classList.add('-out-left');
            newSlide.classList.add('-in-right');
        } else {
            currentSlide.classList.add('-out-right');
            newSlide.classList.add('-in-left');
        }
    }

    nextSlide() {
        let index = this.slideIndex + 1;
        if(index > this.getSlides().length - 1) {
            index = 0;
        }
        this.changeSlide(index, true);
    }

    prevSlide() {
        let index = this.slideIndex - 1;
        if(index < 0) {
            index = this.getSlides().length - 1;
        }
        this.changeSlide(index, false);
    }

    onButtonClick(index) {
        this.changeSlide(index);
    }

    onAutoTimeout() {
        this.nextSlide();
    }

    getElement() {
        return this.element;
    }

    getSlideIndex() {
        return this.slideIndex;
    }

    getCurrentSlide() {
        return this.getSlides()[this.slideIndex];
    }

    getSlides() {
        return this.getElement().querySelectorAll('.bl-banner-carousel-slide');
    }

    getButtons() {
        return this.getControlsElement().querySelectorAll('ol button');
    }

    getControlsElement() {
        return this.getElement().querySelector('.bl-banner-carousel-controls');
    }

    static init() {
        document.querySelectorAll('.bl-banner-carousel').forEach(function(el) {
            new CarouselBannerBlock(el);
        });
    }
};

export default CarouselBannerBlock;
export {
    CarouselBannerBlock
};
